import { Form } from '../backbone/types'
import { useAppSelector } from '../redux/store'

export const useEditorState = () => {
  return useAppSelector((state) => state.editor) || ({} as Form)
}
